module.exports = __webpack_public_path__ + "static/media/network-white.e518dadb.png";